import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "IntegrationPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "IntegrationSection"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatsappIntegration = _resolveComponent("WhatsappIntegration")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$store.state.CookiesConfig.WhatsAppIntegration === 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_WhatsappIntegration)
        ]))
      : _createCommentVNode("", true)
  ]))
}